module.exports = __webpack_public_path__ + "img/zlogo1.f6cc39af.png";